// @ts-expect-error - Automatic, Please fix when editing this file
const selectToast = (state) => state?.toast?.toasts ?? null;

export default selectToast;
